<span (click)="deleteClicked()" class="attr-btn-delete" matSuffix>
  <div class="left-right"></div>
  <div class="right-left"></div>
  <label *ngIf="displayLabel" class="close">delete</label>
</span>
